import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import chat from '../reducers';
import promiseMiddleware from 'redux-promise-middleware';
import createLogger from 'redux-logger';
import {biLoggerMiddleware, logger, loggerRT} from '../biLogger';

export default function configureStore() {
  let debugLoggingMiddlewares = [];  // eslint-disable-line prefer-const
  if (window.isDebug) {
    debugLoggingMiddlewares.push(createLogger());
  }

  const middlewares = [
    promiseMiddleware(),
    thunk,
    biLoggerMiddleware(logger, loggerRT),
    ...debugLoggingMiddlewares
  ];

  const composeStoreWithMiddleware = applyMiddleware(...middlewares)(createStore);

  return composeStoreWithMiddleware(chat);
}



// WEBPACK FOOTER //
// ./chat-app/store/configureStore.js